import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { CompetitionService } from '../../service/CompetitionService';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import { DataTable } from 'primereact/datatable';
import DataTableUtils from '../../utilities/DataTableUtils';
import { Column } from 'primereact/column';

const CompetitionJobWrittenExamApproveDialog = (props) => {
    const [approved, setApporved] = useState(null);
    const [changesList, setChangesList] = useState([]);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        const getChanges = async () => {
            await competitionService.getCompetitionCalendarChange(props?.competition?.id)
                .then((_changeList) => {
                    // console.log("_changeList: ", _changeList);
                    let _writtenExam = _changeList?.find((item) => item.competitionCalendar.examType === 'WRITTEN_EXAM' && item.approved === null);
                    setChangesList(_changeList?.filter((item) => item.competitionCalendar.examType === 'WRITTEN_EXAM' && item.approved === null));
                    if (_writtenExam) {
                        setApporved(_writtenExam.approved);
                    }
                })
                .catch((error) => error && toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        // console.log(_exam);
        getChanges();
    }, [props, competitionService]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
    };

    const approvedChange = async (approved) => {
        // console.log("approvedChange: ", approved);
        competitionService.approveCompetitionJobCalendarChange(props?.competition?.id, approved)            
        .then(() => {
            if (typeof props.afterSave === 'function') {
                props.afterSave(true, null);
            }
            hideDialog();
        })
        .catch((error) => {
            props.afterSave(null, false, error);
        });
    }

    const formDialogHeader = () => {
        let _status = approved === null ? 'pending' : (approved ? 'approved' : 'rejected')
        return (<>
            <div>{translatedMessage('competition.writtenTest.postpone')}</div>
            <div className={`pill inline-block approve-status-${_status.toLowerCase()}`}>
                {translatedMessage('competition.exam.postpone.' + _status)}
            </div>
        </>)
    };

    const formDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('competition.writtenTest.postpone.reject')} icon="pi pi-times" className="p-button-text p-button-danger" 
                onClick={() => approvedChange(false)} disabled={approved !== null || changesList?.length === 0}/>
            <Button label={translatedMessage('competition.writtenTest.postpone.approve')} icon="pi pi-check" className="p-button-text p-button-success" 
                onClick={() => approvedChange(true)} disabled={approved !== null || changesList?.length === 0}/>
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props.visible}
                header={formDialogHeader}
                modal
                onHide={hideDialog}
                className="pcn-dialog p-fluid"
                footer={formDialogFooter}
            >
                <DataTable
                    ref={dt}
                    value={changesList}
                    dataKey="id"
                    // paginator
                    rows={DataTableUtils.defalRowsPerPage()}
                    rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                    className="datatable-responsive pcn-datatable"
                    responsiveLayout="scroll"
                    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    // currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                    sortField='examDate'
                    sortOrder={1}
                >
                    <Column
                        field="competitionCalendar.examType"
                        header={translatedMessage('competition.exam.name')}
                        sortable
                        headerStyle={{ width: '20%', minWidth: '10rem' }}
                        body={(e) => CompetitionUtils.getExamNameByType(e.competitionCalendar)}
                    />
                    <Column
                        field="oldExamDate"
                        header={translatedMessage('competition.calendar.exam.panned')}
                        sortable
                        headerStyle={{ width: '40%', minWidth: '10rem' }}
                        body={(e) => {
                            return (<>
                                <div className='mb-1'>
                                    <span className="font-bold">{translatedMessage('competition.exam.examDate') + ": "}</span>
                                    <span>{GeneralUtils.formatDateTime(e.oldExamDate)}</span>
                                </div>
                                <div>
                                    <span className="font-bold">{translatedMessage('competition.exam.examLocation') + ": "}</span>
                                    <span>{e.oldExamLocation}</span>
                                </div>
                            </>)
                        }}
                    />
                    <Column
                        field="examDate"
                        header={translatedMessage('competition.calendar.exam.posponed')}
                        sortable
                        headerStyle={{ width: '40%', minWidth: '10rem' }}
                        body={(e) => {
                            return (<>
                                <div className='mb-1'>
                                    <span className="font-bold">{translatedMessage('competition.exam.examDate') + ": "}</span>
                                    <span>{GeneralUtils.formatDateTime(e.examDate)}</span>
                                </div>
                                <div>
                                    <span className="font-bold">{translatedMessage('competition.exam.examLocation') + ": "}</span>
                                    <span>{e.examLocation}</span>
                                </div>
                            </>)
                        }}
                    />
                </DataTable>

            </Dialog>
        </>
    );
};

export default CompetitionJobWrittenExamApproveDialog;